import * as React from 'react';
import { getTranslator, TranslatorKeys } from '../Translator';
import { useAppSelector } from '../hooks';

type ContactInstitutionProps = {
    title: TranslatorKeys;
}

export const ContactInstitution = (props: ContactInstitutionProps) => {
    const language = useAppSelector(state => state.language);
    const contactMailLink = useAppSelector(state => state.clientState.ContactMailLink);
    const contactWebsiteLink = useAppSelector(state => state.clientState.ContactWebsiteLink);
    const contactPhone = useAppSelector(state => state.clientState.ContactPhone);

    const translator = getTranslator(language);
    const title = translator[props.title];
    return <p>
        <>{title}</>:
        {contactMailLink ? <span><br /><a href={contactMailLink}>Email</a></span> : null}
        {contactWebsiteLink ? <span><br /><a href={contactWebsiteLink} target="_blank" rel="noreferrer noopener">Website</a></span> : null}
        {contactPhone ? <span><br /><a href={'tel:' + contactPhone}>{translator['Phone']}: {contactPhone}</a></span> : null}
    </p>
}
